module.exports = __webpack_public_path__ + "img-gestao--c66b7fdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/img-gestao.jpg
// module id = 188
// module chunks = 0